import { FloatingArrow } from '@floating-ui/react'
import styled from 'styled-components'

import { helpers } from '../../styles/theme'

export const Arrow = styled(FloatingArrow)`
	fill: ${helpers.color.background};
`
